const escapeRegExp = (value) =>
  String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** Normalize for spam matching: lowercase, strip zero-width chars, collapse spaces. */
export const normalizeSpamText = (value) =>
  String(value || "")
    .normalize("NFKC")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

const phraseFromItem = (item) => {
  if (item == null) return "";
  if (typeof item === "string" || typeof item === "number") {
    return String(item);
  }
  return String(item.phrase ?? item.phraseText ?? item.text ?? "").trim();
};

/**
 * Whole-word / whole-phrase spam match.
 * "score" matches "score" / "the score is", but not "scored" or "myscore".
 */
export const containsSpam = (plainText, spamPhrases) => {
  const text = normalizeSpamText(plainText);
  const found = [];

  if (!text || !Array.isArray(spamPhrases)) return found;

  // Single-word lookup via tokens — avoids substring false positives.
  const tokens = new Set(text.split(/[^a-z0-9_]+/).filter(Boolean));

  for (const item of spamPhrases) {
    const phrase = normalizeSpamText(phraseFromItem(item));
    if (!phrase) continue;

    if (!phrase.includes(" ")) {
      if (tokens.has(phrase)) {
        found.push(phrase);
      }
      continue;
    }

    try {
      const escaped = escapeRegExp(phrase);
      const regex = new RegExp(
        `(^|[^a-z0-9_])${escaped}(?=[^a-z0-9_]|$)`,
        "i"
      );
      if (regex.test(text)) {
        found.push(phrase);
      }
    } catch (_) {
      // Skip phrases that cannot form a valid regex.
    }
  }

  return Array.from(new Set(found));
};

export default containsSpam;
